// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './App.css';

// Load Google Fonts
const link1 = document.createElement('link');
link1.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap';
link1.rel = 'stylesheet';

const link2 = document.createElement('link');
link2.href = 'https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@400;500;600&display=swap';
link2.rel = 'stylesheet';

document.head.appendChild(link1);
document.head.appendChild(link2);

// Check for speech synthesis support
if (!('speechSynthesis' in window)) {
  console.warn('Speech synthesis not supported in this browser');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);